import { useDndContext } from '@dnd-kit/core';
import { sentenceInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { facit, input } from './input.content.style.js';
import { jsx } from 'react/jsx-runtime';

function SentenceInput(props) {
  const context = useTaskContext();
  const dndContext = useDndContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => sentenceInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const state = useInputState(props.node, inputEntry);
  if (state === "correct" || state === "incorrect") {
    return /*#__PURE__*/jsx(StateBox, {
      state: state,
      textTheme: "colored",
      children: /*#__PURE__*/jsx("div", {
        className: facit,
        children: props.node.text
      })
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: input,
    "data-state": props.node.options.fixed ? "fixed" : state,
    "data-context": context,
    "data-is-dragged": dndContext.active && props.isDraggingItem,
    "data-is-overlay": props.isDragOverlay,
    children: props.node.text
  });
}

export { SentenceInput };
//# sourceMappingURL=input.content.js.map
